import React, { useMemo } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

import CreateWizardLayout from '../../../../components/CreateWizardLayout';
import Button from '../../../../../../components/global/Button';
import DismissButton from '../../../../../../components/global/DismissButton';

const propTypes = {
  activeStep: PropTypes.shape({
    key: PropTypes.string,
    component: PropTypes.node,
  }),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  values: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

const FremiumEventTutorialActionModal = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  handleSubmit,
  user,
  steps,
  stepProps,
  stepsObject,
  activeStepIndex,
  isOpen,
  onClose,
  onSkip,
  submitting,
}) => {
  const { purchasedAddonItems } = stepProps;
  const activeStep = steps[activeStepIndex];
  const ActiveStep = useMemo(() => activeStep.component, [
    activeStep.key,
    purchasedAddonItems,
  ]);

  return (
    <Modal
      key={activeStepIndex}
      ariaHideApp={false}
      isOpen={isOpen}
      className="freemium-event-tutorial-action-modal"
      bodyOpenClassName="body-modal-open"
      overlayClassName="modal-overlay"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {onClose && (
            <DismissButton
              onClick={onClose}
              className="freemium-event-purchase-dismiss"
            />
          )}

          <span className="text-uppercase text-xs text-extra-bold text-primary mb-2">
            Complete your setup ({activeStepIndex + 1}/{steps.length})
          </span>
          <CreateWizardLayout.Wrapper>
            <CreateWizardLayout.Content size={activeStep.layoutSize ?? 'md'}>
              <h2 className="text-center">{activeStep.title}</h2>
              <ActiveStep
                user={user}
                values={values}
                touched={touched}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                handleBlur={handleBlur}
                steps={stepsObject}
              />

              <Button
                type="submit"
                onClick={handleSubmit}
                className="freemium-event-tutorial-action-btn"
                disabled={submitting}
                {...(activeStep.modalActionBtnProps ?? {})}
              >
                {submitting
                  ? 'Processing...'
                  : activeStep?.modalActionBtnLabel ?? 'Continue'}
              </Button>

              {!!activeStep.modalSkipBtnLabel && (
                <Button
                  btnStyle="link"
                  btnSize="sm"
                  className="mx-auto mt-2 d-flex skip-button text-bold"
                  onClick={() => {
                    onSkip({ values, handleChange });
                  }}
                  disabled={submitting}
                  {...(activeStep.modalSkipBtnProps ?? {})}
                >
                  <span>{activeStep?.modalSkipBtnLabel}</span>
                </Button>
              )}
            </CreateWizardLayout.Content>
          </CreateWizardLayout.Wrapper>
        </div>
      </div>
    </Modal>
  );
};

FremiumEventTutorialActionModal.propTypes = propTypes;

export default FremiumEventTutorialActionModal;
